import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";
import type { FeedbackFormProps } from "./feedback-form-displayed";

export type FeedbackFormAnsweredProps = FeedbackFormProps & {
  answer: string;
};

export type FeedbackFormAnsweredEvent = TrackingEvent<
  "Feedback Form Answered",
  { form_question: string; form_answer: string }
>;

export async function trackFeedbackFormAnsweredEvent({
  question,
  answer,
}: FeedbackFormAnsweredProps): TrackingEventResponse {
  return await trackEvent("Feedback Form Answered", {
    props: { form_question: question, form_answer: answer },
    withRequestSource: true,
  });
}
